<template>
    <div class="dml-product-thumb__labels">
        <div v-if="showTopLabels"
             class="dml-product-thumb__labels-items dml-product-thumb__labels-items--top">
            <dm-product-label v-if="inPromoSales && promoSale"
                              type="promo-sales"
                              :data-ga="dataGA"
                              data-ga-label="badge_promo-sale"
                              data-t="8.11">
                <img :src="promoSale.badgeImageUrl"
                     :srcset="`${promoSale.badgeLargeImageUrl} 2x`"
                     alt="Akcja promocyjna" />
            </dm-product-label>
            <dm-product-label v-if="discountPercent"
                              type="promo-circle"
                              data-trc="productThumb.sale"
                              :data-ga="dataGA"
                              data-ga-label="badge_sale"
                              data-t="8.8">
                -{{discountPercent}}
            </dm-product-label>
            <dm-product-label v-if="isNewProduct"
                              type="white-circle"
                              :data-ga="dataGA"
                              data-ga-label="badge_new"
                              data-t="8.9">
                Nowe
            </dm-product-label>
        </div>
        <div v-if="showBottomLabels"
             class="dml-product-thumb__labels-items dml-product-thumb__labels-items--bottom">
            <dm-product-label v-if="isDiscountHunters"
                              type="promo"
                              :data-ga="dataGA"
                              data-ga-label="badge_discount-hunters">
                Łowcy okazji
            </dm-product-label>
            <dm-product-label v-if="isLastItems"
                              type="last-items"
                              :data-ga="dataGA"
                              data-ga-label="badge_last-items">
                <dm-icon name="clock-2"
                         :width="16"
                         :height="16" />
                Ostatnie szt.
            </dm-product-label>
            <dm-product-label v-if="isBestseller"
                              type="white"
                              :data-ga="dataGA"
                              data-ga-label="badge_bestseller"
                              data-t="8.10">
                Popularne
            </dm-product-label>
        </div>
    </div>
</template>
<script>
    import * as types from '../../store/types.js';
    import ProductLabel from './product-label-component.vue';
    import IconComponent from '../shared/icon-component.vue';

    export default {
        name: 'dm-product-details-labels',
        components: {
            'dm-product-label': ProductLabel,
            'dm-icon': IconComponent,
        },
        props: {
            isNewProduct: {
                type: Boolean,
                required: true
            },
            isBestseller: {
                type: Boolean,
                required: true
            },
            isInPromoSales: {
                type: Boolean,
                required: true
            },
            isDiscountHunters: {
                type: Boolean,
                required: true
            },
            isLastItems: {
                type: Boolean,
                required: true
            },
            discountPercent: {
                type: String
            },
            dataGA: {
                type: String,
                required: true
            },
            promoSale: {
                type: Object,
                required: false
            }
        },
        computed: {
            showTopLabels() {
                return this.discountPercent || this.isNewProduct || this.inPromoSales;
            },
            showBottomLabels() {
                return this.isBestseller || this.isDiscountHunters || this.isLastItems;
            },
            currentPromoSale() {
                return DM.Service.PromoSales;
            },
            inPromoSales() {
                return this.isInPromoSales && this.currentPromoSale;
            },
        },
    };
</script>
